import React from 'react';
import { ModalBodyContentBoxProps } from '../../types';
import * as S from './styled';

export const ModalBodyContentBox: React.FC<ModalBodyContentBoxProps> = React.memo(
  ({
    isFormWrapper,
    onFormSubmit,
    children,
    infoOrErrorOrWarning,
    formProps,
    containerWidth,
    contentContainerRef,
    modalId,
    willBeGraySurface,
    customStyled,
  }) => {
    if (isFormWrapper) {
      return (
        <S.ModalContentBodyForm
          //@ts-expect-error
          ref={contentContainerRef}
          $infoOrErrorOrWarning={!!infoOrErrorOrWarning}
          $graySurface={willBeGraySurface}
          $containerWidth={containerWidth}
          $customStyled={customStyled}
          onSubmit={onFormSubmit}
          {...formProps}
          aria-modal="true"
          aria-labelledby={modalId ? `${modalId}-modal-title` : 'modal-title'}
          aria-describedby={modalId ? `${modalId}-modal-content` : 'modal-content'}
        >
          {children}
        </S.ModalContentBodyForm>
      );
    }
    return (
      <S.ModalContentBodyDiv
        //@ts-expect-error
        ref={contentContainerRef}
        $infoOrErrorOrWarning={!!infoOrErrorOrWarning}
        $containerWidth={containerWidth}
        $graySurface={willBeGraySurface}
        $customStyled={customStyled}
        aria-modal="true"
        aria-labelledby={modalId ? `${modalId}-modal-title` : 'modal-title'}
        aria-describedby={modalId ? `${modalId}-modal-content` : 'modal-content'}
      >
        {children}
      </S.ModalContentBodyDiv>
    );
  }
);
ModalBodyContentBox.displayName = 'ModalBodyContentBox';

export default ModalBodyContentBox;
